// extracted by mini-css-extract-plugin
export default {"component":"aXgr1p","mobile":"g7jNB9"};